import moment from 'moment';
import { Contributor } from '@/models/financeiro/contributor';
import { ProductEnumAll } from '@/models/financeiro/enum/product.enum';
import { RevenueEnumAll } from '@/models/financeiro/enum/revenue.enum';
import { DaeStatusEnumAll } from '@/models/financeiro/enum/dae-status.enum';
import {
  RevenueStatusEnumAll,
  RevenueStatusEnum,
} from '@/models/financeiro/enum/revenue-status.enum';
import { RevenueTypeEnumAll } from '@/models/financeiro/enum/revenue-type.enum';
import { CompetenciaFormatEnum } from '@/models/financeiro/enum/competencia-format.enum';
import { formatCpfCnpjDisplay } from '@/helpers/cpf-cnpj-display';

moment.locale('pt-BR');

export const revenueTypeFormat = (value: string): string => {
  if (!value && value !== '') return '';

  const { key } = RevenueTypeEnumAll.find(revenue => {
    return revenue.value.valueOf() === Number(value);
  });
  return key;
};

export const revenueStatusFormat = (value: string): string => {
  if (!value && value !== '') return '';

  const { key } = RevenueStatusEnumAll.find(status => status.value === RevenueStatusEnum[value]);
  return key;
};

export const revenueFormat = (value: string): string => {
  if (!value && value !== '') return '';

  const { key } = RevenueEnumAll.find(revenue => {
    return revenue.value.valueOf() === Number(value);
  });
  return key;
};

export const daeStatusFormat = (value: string): string => {
  if (!value && value !== '') return '';

  const { key } = DaeStatusEnumAll.find(status => status.value.valueOf() === Number(value));
  return key;
};

export const productFormat = (value: string): string => {
  if (!value && value !== '') return '';

  const { key } = ProductEnumAll.find(product => product.value.valueOf() === Number(value));
  return key;
};

export const dateFormat = (value: string): string =>
  (!!value && moment(value).format('DD/MM/YYYY')) || '';
export const dateFormatCustom = (value: string, format: string): string =>
  moment(value).format(format);

export const monetaryFormat = (value: number, decimal: number = 2): string => {
  if (!value) return `0,${'0'.repeat(decimal)}`;
  let val = Number(value).toFixed(decimal).replace('.', ',');
  const splitVal = val.split(',');
  return `${splitVal[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${splitVal[1]}`;
};

export const cnpjCpfFormat = (cnpjCpf: string) => {
  if (!cnpjCpf) return '';

  return formatCpfCnpjDisplay(cnpjCpf);
};

export const contributorFormat = (item: Contributor, queryText: string): boolean => {
  const { nomeFantasia = '', nomeRazaoSocial = '', cpfCnpj = '' } = item || {};
  return (
    (nomeFantasia &&
      nomeFantasia.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1) ||
    (nomeRazaoSocial &&
      nomeRazaoSocial.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1) ||
    (cpfCnpj && cpfCnpj.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1)
  );
};

export const competenciaFormat = (
  competencia: string,
  pattern: CompetenciaFormatEnum = CompetenciaFormatEnum.MES_ANO
) => {
  if (!competencia) return null;
  return moment(competencia).format(CompetenciaFormatEnum[pattern]);
};

export const getNumberFromString = (value: any): Number => {
  if (value === undefined || value === null) return null;
  if (typeof value === 'number') return value;
  return Number(value.replace(/\./g, '').replace(',', '.'));
};

export const getStringFromNumber = (value: number): string => {
  if (value === undefined || value === null) return null;
  const formatted = (value > 999 && value.toString()) || value.toLocaleString('pt-BR');
  return formatted;
};

export const currencyOptions: Object = {
  currency: null,
  locale: 'pt-BR',
  'allow-negative': false,
  'distraction-free': false,
};
